import React from "react";
import { Link } from "react-router-dom";

export default function Pagenotfound({ title = "Page Not Found" }) {
  return (
    <div
      className="container text-center d-flex align-items-center"
      style={{ minHeight: "50vh" }}
    >
      <div className="row justify-content-center w-100">
        <div className="col-md-6">
          <div className="display-1 fw-bold text-anime-style-3 my-3">
            {title}
          </div>

          <p className="text-muted mb-4">
            Sorry, the page you are looking for doesn’t exist or has been moved.
          </p>

          <Link to="/" className="btn-default">
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
}
